<script>
  // packages
  import { afterUpdate } from 'svelte';

  // utils
  import { clamp } from '../../../utils/clamp';

  /** @type {number} */
  export let x;
  /** @type {number} */
  export let y;
  /** @type {number} */
  export let padding = 20;

  /** @type {HTMLDivElement} */
  let tooltipElement;
  /** @type {number} */
  let innerWidth;
  /** @type {number} */
  let innerHeight;

  /** @type {number} */
  let width;
  /** @type {number} */
  let height;

  $: left = clamp(x - width / 2, padding, innerWidth - width - padding);
  $: top =
    innerHeight > y + padding * 2 + height ? y + padding : y - height - padding;

  afterUpdate(() => {
    const bounds = tooltipElement.getBoundingClientRect();

    width = bounds.width;
    height = bounds.height;
  });
</script>

<svelte:window bind:innerWidth bind:innerHeight />

<div
  class="svelte-tooltip"
  style="left: {left}px; top: {top}px;"
  bind:this={tooltipElement}
>
  <slot />
</div>
